import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

/**
 * One sidebar entry.
 *
 * Kept out of ShellChrome so that file exports components only — Fast Refresh
 * silently stops preserving state for a module that mixes the two.
 */
export function navItem(path: string, label: string, icon: ReactNode) {
  return { key: path, icon, label: <Link to={path}>{label}</Link> };
}
